interface IAgentManager {
    registerInstance: (id: string, ref: Element, cleanUp: VoidFunction) => void;
    unRegisterInstance: (id: string) => void;
    getInstance: (id?: string) => null | Element;
    getInstancesCount: () => number;
}

class AgentManager implements IAgentManager {
    instances: {
        [key: string]: Element;
    };

    cleanUps: {
        [key: string]: VoidFunction;
    };

    constructor() {
        this.instances = {};
        this.cleanUps = {};
    }

    registerInstance = (id: string, ref: Element, cleanUp: VoidFunction) => {
        this.instances[id] = ref;
        this.cleanUps[id] = cleanUp;
    };

    unRegisterInstance = (id: string) => {
        this.cleanUps[id]?.();
        delete this.instances[id];
        delete this.cleanUps[id];
    };

    getInstance = (id?: string) => {
        if (!id) {
            return null;
        }
        return this.instances[id] as Element;
    };

    getInstancesCount = () => {
        return Object.keys(this.instances).length;
    };
}

export default AgentManager;
